(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/start/assets/react/components/start-text.js') >= 0) return;  svs.modules.push('/modules/lotto/components/start/assets/react/components/start-text.js');

'use strict';

const simpleTime = svs.utils.date.SimpleTime;
const _svs$numbergames = svs.numbergames,
  _svs$numbergames$draw = _svs$numbergames.draws,
  drawsApi = _svs$numbergames$draw.drawsApi,
  jackpotApi = _svs$numbergames$draw.jackpotApi,
  JACKPOT_WINSET = _svs$numbergames.jackpot.CONSTANTS.JACKPOT_WINSET,
  productMapping = _svs$numbergames.productMapping;
const getJackpot = winset => {
  const jackpot = jackpotApi.jackpot({
    product: productMapping.CONSTANTS.LOTTO,
    winset
  });
  const tag = jackpot.tag || 'ca';
  const amountString = jackpot.jackpotAmountString.replace('ca', '');
  return {
    tag,
    amountString
  };
};
const StartText = () => {
  const _getJackpot = getJackpot(JACKPOT_WINSET.LOTTO_1),
    lotto1JackpotTag = _getJackpot.tag,
    lotto1JackpotAmountString = _getJackpot.amountString;
  const _getJackpot2 = getJackpot(JACKPOT_WINSET.DROMVINST),
    dromvinstTag = _getJackpot2.tag,
    dromvinstAmountString = _getJackpot2.amountString;
  const closeTimeWednesday = simpleTime(drawsApi.regCloseTime('onslotto'));
  const closeTimeSaturday = simpleTime(drawsApi.regCloseTime('lorlotto'));
  let closeTimeText = "Spelstopp onsdagar kl ".concat(closeTimeWednesday, " och l\xF6rdagar kl ").concat(closeTimeSaturday);
  if (closeTimeWednesday === closeTimeSaturday) {
    closeTimeText = "Spelstopp ".concat(closeTimeWednesday, " l\xF6rdagar och onsdagar");
  }
  return React.createElement("div", {
    className: "start-text js-start-text"
  }, React.createElement("p", null, "Dr\xF6mvinsten ".concat(dromvinstTag, " "), React.createElement("span", {
    className: "f-bold"
  }, dromvinstAmountString), " kronor"), React.createElement("p", null, "Jackpot Lotto 1 ".concat(lotto1JackpotTag, " "), React.createElement("span", {
    className: "f-bold"
  }, lotto1JackpotAmountString), " kronor"), React.createElement("p", null, closeTimeText));
};
setGlobal('svs.lotto.react.components', {
  StartText
});

 })(window);